export default "__VITE_ASSET__7b778044__"